import {Link, useRouteNode} from "react-router5";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import './style/style.css';
import {setTheme} from "../redux/theme/themeSlice";
import {setLang} from "../redux/lang/langSlice";
import {useTranslation} from "react-i18next";
import {NotificationMenu} from "./notification";
import {AppUpdateMenu} from "./app_update_menu";

const SettingsMenu = ({subroot,router, cgu_activated}) =>{
  const user = useSelector((state) => state.current_user.user);

  const mail = "support@reticularproject.com";

  const { t } = useTranslation();
    return (
        <div className={'settingsMenuContainer'}>
            <div className={'settingsMenuProfil'}>
                <img className={'settingsMenuImgProfil'} src={user.img} alt={user.firstname}/>
                <div className={'settingsMenuNameProfil'}>{user.firstname} {user.lastname}</div>
            </div>
            <div className={'settingMenuMainItemContainer'}>
                <Link className="settingMenuItemContainer" href="" routeName={"settings.apparence"} routeOptions={{reload: true}}>
                  {t('Apparence')}
                  <span className={'settingMenuItemChevron'} />
                </Link>
		{
		// pin: deactivate
		false &&
                <div className="settingMenuItemContainer" onClick={()=>{window.location.href = router.buildPath("setPin");}}>
                  {t('Confidentialité')}
                  <span className={'settingMenuItemChevron'} />
                </div>
		}
                <Link className="settingMenuItemContainer" href="" routeName={"settings.langue"} routeOptions={{reload: true}}>
                  {t('Langue')}
                  <span className={'settingMenuItemChevron'} />
                </Link>

		{
		  cgu_activated &&
		  <Link className="settingMenuItemContainer" href="" routeName={"settings.cgu"} routeOptions={{reload: true}}>
		    {t('GCU')}
		    <span className={'settingMenuItemChevron'} />
		  </Link>
		}

                <Link className="settingMenuItemContainer" href="" routeName={"settings.notification"} routeOptions={{reload: true}}>
                  {t('Notification')}
                  <span className={'settingMenuItemChevron'} />
                </Link>
                <Link className="settingMenuItemContainer" href="" routeName={"settings.app_update"} routeOptions={{reload: true}}>
                  {t('Application update')}
                  <span className={'settingMenuItemChevron'} />
                </Link>
                <a className="settingMenuItemContainer" href={'mailto:' + mail}>
                  {t('Contacter l\'administrateur')}
                  <span className={'settingMenuItemChevron'} />
                </a>
            </div>
        </div>
    )
}

const ApparenceMenu = () =>{
    const { t } = useTranslation();

    const theme = useSelector((state) => state.theme.value);
    const dispatch = useDispatch();

    function changeTheme(theme){
        dispatch(setTheme(theme));
    }
    return (
    <div className={'MainMenuContainer'}>
        <div className={'topMainMenu'}>
            <Link routeName='settings' routeOptions={{reload: true}}>  <div className={'topMainBack'}></div></Link>
            <div className={'topMainTitle'}>{t('Apparence de l\'application')}</div>
        </div>
        <div onClick={()=>{changeTheme('light')}} className={'MainMenuItem'}>{t('Claire')} {theme==='light' && <div className={'MainMenuItemChecked'}></div>}</div>
        <div onClick={()=>{changeTheme('dark')}}  className={'MainMenuItem'}>{t('Sombre')} {theme==='dark' && <div className={'MainMenuItemChecked'}></div>}</div>
    </div>)
}

const LangMenu = () =>{
  const { t } = useTranslation();
    const lang = useSelector((state) => state.lang.value);
    const dispatch = useDispatch();
    const { i18n } = useTranslation();

    function changeLang(lang){
        i18n.changeLanguage(lang);
        dispatch(setLang(lang));
        window.location.reload();
    }

    return (
        <div className={'MainMenuContainer'}>
            <div className={'topMainMenu'}>
                <Link routeName='settings' routeOptions={{reload: true}}>  <div className={'topMainBack'}></div></Link>
                <div className={'topMainTitle'}>{t('Langue de l\'application')}</div>
            </div>
            <div onClick={()=>{changeLang('fr')}} className={'MainMenuItem'}>{t('Français')} {lang==='fr' && <div className={'MainMenuItemChecked'}></div>}</div>
            <div onClick={()=>{changeLang('en')}}  className={'MainMenuItem'}>{t('English')} {lang==='en' && <div className={'MainMenuItemChecked'}></div>}</div>
        </div>)
}

const CGUMenu = ({ cgu }) => {
  const { t } = useTranslation();

  const build_link = ({download_url, filename}) => {
    return <a href={download_url} rel="noreferrer" target='_blank'  className={'postFileContainer'} download>
      <div className={'containerNamePictoFile'}>
	<div className={'filePicto'}/>
	<div className={'fileName'}>{filename}</div>
      </div>
      <div className={'flechePicto'}/>
    </a>
  }

  return <div className={'MainMenuContainer'}>
    <div className={'topMainMenu'}>
      <Link routeName='settings' routeOptions={{reload: false}}><div className={'topMainBack'}></div></Link>
    </div>
    <div className={'topMainTitle'}>{t('General Conditions of Use')}</div>
    <div className={'MainMenuItem'}>
      Francais { build_link({ download_url: "/app_config/file/cgu/fr", filename: cgu.pdf_en }) }
    </div>
    <div className={'MainMenuItem'}>
      English { build_link({ download_url: "/app_config/file/cgu/en", filename: cgu.pdf_fr  }) }
    </div>
  </div>
}

function AppSettings() {
    const { route: {name, data}, router } = useRouteNode('settings');
    const [, subroot] = name.split('.');

    const cgu_activated = data.cgu.last_version_at !== null;

    return (
        <div className="c-container_global">
            <section className="c-container container_one" style={{width: "30%", minHeight: "100%"}}>
                <SettingsMenu router={router} subroot={subroot} cgu_activated={cgu_activated} />
            </section>
            { subroot === "apparence" && <ApparenceMenu />}
            { subroot === "langue" && <LangMenu /> }
            { subroot === "cgu" && cgu_activated && <CGUMenu cgu={data.cgu} /> }
            { subroot === "notification" && <NotificationMenu /> }
            { subroot === "app_update" && <AppUpdateMenu /> }
        </div>
    )
}


export default AppSettings
